module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-1-f5a911028f4df3ca9307f5e31679f3e2.jpg";